const NewRainbowRenew = resolve => {
    import(/* webpackChunkName: 'newRainbowRenew' */'../views/newrainbow/renew').then(newRainbowRenew => {
        resolve(newRainbowRenew)
    })
}
export default [
    {
        path: '/newrainbow/renew',
        name: 'newRainbowRenew',
        component: NewRainbowRenew,
        meta: {
            title: '到期续订'
        }
    }
]
